import type { OTPMethod } from '@/lib/services/authentica';

/**
 * Which delivery channel the OTP copy should name (#22).
 *
 * The admin picks SMS or WhatsApp in settings/authenticaApi.otpMethod and the
 * server's sendOtpCode reports the channel it actually used. Copy must follow
 * that, never a hard-coded default:
 *   1. once a code was sent, the server-reported method wins;
 *   2. before that, the admin setting (useOTPMethod) once it has loaded;
 *   3. while the setting is still loading, `null` — show channel-neutral copy
 *      instead of flashing «واتساب» on an SMS deployment.
 */
export function resolveOtpChannel(
  settingMethod: OTPMethod,
  settingLoading: boolean,
  sentVia?: OTPMethod | null,
): OTPMethod | null {
  if (sentVia) return sentVia;
  if (settingLoading) return null;
  return settingMethod;
}
